import axios from 'axios';
import authService from './authService';
import {history} from '../../_helpers';
import alertService from './alert.service';

const apiUrl = process.env.REACT_APP_API_URL;

class Request {

    baseURL;
    isRefreshing: boolean;

    refreshToken:any;
    failedRequests:any[];
    client;

    constructor() {
        this.baseURL = apiUrl;
        this.isRefreshing = false;
        this.refreshToken = undefined;
        this.failedRequests = [];
        this.client = axios.create({
            baseURL: apiUrl,
            headers: {}
        });
        this.onRequestFailure = this.onRequestFailure.bind(this);
        this.client.interceptors.request.use(this.beforeRequest);
        this.client.interceptors.response.use(
            this.onRequestSuccess,
            this.onRequestFailure);
    }

    beforeRequest = (request:any) => {

        const uaLocalstorage = localStorage.getItem('userAutopartes')
        let user = uaLocalstorage?JSON.parse(uaLocalstorage):undefined;
        let token = '';
        if (user) {
            token = user.token;
            this.refreshToken = user.refreshToken;
        }
        // Ojo: no reemplazar el objeto `headers` entero. Axios 1.x lo usa para mergear
        // los headers por-request (p.ej. el multipart/form-data de subirImagen), y
        // pisarlo dejaba esas subidas con Content-Type json.
        request.headers.set('Authorization', `Bearer ${token}`);
        if (!request.headers.get('Content-Type')) {
            request.headers.set('Content-Type', 'application/json');
        }
        return request;
    }

    onRequestSuccess = (response:any) => {
        if (response.data && response.data.status === 2) return Promise.reject(response.data)
        return response.data;
    }

    async onRequestFailure(err:any) {
        let parseError = {}

        if (!err.response) {
            parseError = {
                codigo: 3,
                message: 'No se ha podido establecer una conexión con el servidor, intente nuevamente en unos segundos'
            }
        } else {
            const {response} = err;
            if ((response.status === 401 || response.status === 403) && err && err.config && !err.config.__isRetryRequest) {
                if (this.isRefreshing) {
                    try {
                        const token = await new Promise((resolve, reject) => {
                            this.failedRequests.push({resolve, reject});
                        });
                        err.config.headers.authorization = `Bearer ${token}`;
                        return this.client(err.config);
                    } catch (e) {
                        return e;
                    }
                }
                this.isRefreshing = true;
                err.config.__isRetryRequest = true;
                return new Promise((resolve, reject) => {
                    this.refrescarToken().then((token) => {
                        err.config.headers.Authorization = `Bearer ${token}`;
                        this.isRefreshing = false;
                        this.processQueue(null, token);
                        resolve(this.client(err.config));
                    }).catch((e) => {
                        this.processQueue(e, null);
                        reject(err.response);
                    });
                });
            }
            // El mensaje del backend primero: `statusText` es genérico ("Bad Request") y
            // tapaba la causa real, que es lo único accionable para el usuario.
            const data = response.data || {};
            parseError = {
                codigo: response.status,
                message: data.message || data.error || response.statusText || 'Ocurrió un error inesperado'
            }
        }

        throw parseError;
    }

    processQueue = (error:any, token:any) => {
        this.failedRequests.forEach((prom) => {
            if (error) {
                prom.reject(error);
            } else {
                prom.resolve(token);
            }
        });
        this.failedRequests = [];
    }

    refrescarToken = () => {
        return new Promise((resolve, reject) => {
            if (this.refreshToken === null || this.refreshToken === undefined) {
                reject('No refresh token');
            } else {
                let url = apiUrl + 'auth/refreshToken';
                let res = fetch(url, {
                    method: 'POST',
                    headers: new Headers({'content-type': 'application/json'}),
                    body: JSON.stringify({refreshToken: this.refreshToken}),
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    redirect: 'follow',
                    referrer: 'no-referrer'
                })
                    .then((response) => response.json())
                    .then((data:any) => {
                        console.log('resfresh:', data)
                        if(data){                           
                            localStorage.setItem('userAutopartes', JSON.stringify(data.user.token));
                            authService.userLoginSucess();
                            authService.setExtraInfo(data.user); 
                            resolve(data.user.token.token);
                        }else{
                            reject('Could not refresh');
                            authService.userLogout();
                            history.push('/');
                        }
                      
                    })
                    .catch((e) => {
                        reject('Could not refresh');
                        console.log(e);
                        authService.userLogout();
                        history.push('/');
                    });
            }


        });
    }
}


const request = new Request();

export default request.client;